import { render, staticRenderFns } from "./_Itemized.vue?vue&type=template&id=1a71bae7&scoped=true&"
import script from "./_Itemized.vue?vue&type=script&lang=js&"
export * from "./_Itemized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a71bae7",
  null
  
)

export default component.exports